import { IFormValidation } from '@aston/foundation';

export class ICreateRegistrationUserSubsidiaryValidator implements IFormValidation {
	ruleset = 'createRegistrationUserSubsidiaryCommandValidator';
	fields = {
		UserName: 'UserName',
		SubsidiaryRole: 'SubsidiaryRole',
		SubsidiaryId: 'subsidiaryId'
	};
}

export const CreateRegistrationUserSubsidiaryValidator = new ICreateRegistrationUserSubsidiaryValidator();
